import { types } from 'mobx-state-tree';

const ReviewDescription = types.model('ReviewDescription', {
  admin_reply: types.maybeNull(types.string),
  language: types.maybeNull(types.string),
  reviews_text: types.string,
});

export default ReviewDescription;
